// product-accordion.js
// Smooth, symmetrical open/close animation for product page accordions
// (description, collapsible tabs, complementary products row, etc.)
// Replaces the native <details> snap-open / no-animation-close behavior.

(function () {
  var SELECTOR = '.product__accordion.accordion details, .accordion details';
  var DURATION = 300; // ms, keep in sync with CSS if you reference it anywhere

  function initAccordion(details) {
    if (details.dataset.accordionInit) return;
    details.dataset.accordionInit = 'true';

    var summary = details.querySelector(':scope > summary');
    var content = details.querySelector(':scope > .accordion__content');
    if (!summary || !content) return;

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.classList.contains('is-animating')) return;

      if (details.hasAttribute('open')) {
        collapse(details, content);
      } else {
        expand(details, content);
      }
    });
  }

  function expand(details, content) {
    details.classList.add('is-animating');
    details.setAttribute('open', '');

    // Start from 0
    content.style.overflow = 'hidden';
    content.style.height = '0px';
    content.style.opacity = '0';

    // Force layout so the browser registers the starting state
    content.offsetHeight; // eslint-disable-line no-unused-expressions

    var endHeight = content.scrollHeight;

    content.style.transition = 'height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
    content.style.height = endHeight + 'px';
    content.style.opacity = '1';

    onTransitionEnd(content, function () {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      content.style.opacity = '';
      details.classList.remove('is-animating');
    });
  }

  function collapse(details, content) {
    details.classList.add('is-animating');

    var startHeight = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = startHeight + 'px';
    content.style.opacity = '1';

    // Force layout before animating to the collapsed state
    content.offsetHeight; // eslint-disable-line no-unused-expressions

    content.style.transition = 'height ' + DURATION + 'ms ease, opacity ' + DURATION + 'ms ease';
    content.style.height = '0px';
    content.style.opacity = '0';

    onTransitionEnd(content, function () {
      details.removeAttribute('open');
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      content.style.opacity = '';
      details.classList.remove('is-animating');
    });
  }

  function onTransitionEnd(el, callback) {
    var done = false;
    function handler(e) {
      if (e && e.target !== el) return;
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      callback();
    }
    el.addEventListener('transitionend', handler);
    // Fallback in case transitionend doesn't fire (e.g. height was already 0)
    setTimeout(handler, DURATION + 50);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for any accordions added later (e.g. complementary products
  // rendered async, or theme editor section reloads)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-recommendations:loaded', init);
})();